import { render } from "./CustomTagsRichText.vue?vue&type=template&id=4d3d01af"
import script from "./CustomTagsRichText.vue?vue&type=script&lang=js"
export * from "./CustomTagsRichText.vue?vue&type=script&lang=js"

import "./CustomTagsRichText.vue?vue&type=style&index=0&id=4d3d01af&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__